import { Category } from "./model/category";
import { Currency } from "./model/currency";

// let local = '';
let dev = "https://api.getscatch.app/api";
let staging = "https://api.getscatch.app/api";
// let prod = '';
let serverStaging = "https://api.getscatch.app/api";

export const baseUrl = staging;
export const serverUrl = baseUrl;
export const URLs = {
  // Admin Auth API
  login: baseUrl + "/admin/login/",
  logout: baseUrl + "/admin/logout",
  forgotPassword: baseUrl + "/admin/forgotPassword",
  changePassword: baseUrl + "/admin/changePassword",
  dashboardData: baseUrl + "/admin/dashboard/",
  allTickets: baseUrl + "/admin/tickets/",
  activeTickets: baseUrl + "/admin/tickets/",
  inactiveTickets: baseUrl + "/tickets/inactive/",
  fakeTickets: baseUrl + "/tickets/flagged/",
  fakeTicketRequests: baseUrl + "/tickets/flagged_requests/",
  approveRejectFakeTicketRequest:
    baseUrl + "/tickets/{ticket_id}/update_flag_status/",
  myTickets: baseUrl + "/users/{user_id}/tickets/",
  markTicketFake: baseUrl + "/tickets/{ticket_id}/flag/",
  updateTicket: baseUrl + "/tickets/{ticket_id}/",
  cancelTicket: baseUrl + "/users/{user_id}/tickets/{ticket_id}/",
  userList: baseUrl + "/users/",
  userUpdateStatus: baseUrl + "/users/{user_id}/update_status/",
  uploadTicketImage: baseUrl + "/images/",
  createNewTicket: baseUrl + "/users/{user_id}/tickets/",
  ticketLog: baseUrl + "/tickets/logs/",
  deleteTicket: baseUrl + "/users/{user_id}/tickets/{ticket_id}/delete/",
  getTicket: baseUrl + "/tickets/detail/?ticket_id={ticket_id}",
  reportedSellers: baseUrl + "/users/requested_report_user_list/",
  updateReportedSellerStatus: baseUrl + "/users/{user_id}/update_report_user/",
  updateFakeTicketCount: baseUrl + "/users/update_fake_count/",
  getFakeTicketCount: baseUrl + "/users/get_fake_count/",
  // Parse tickets
  parseTicketsFromUrl: baseUrl + "/admin/parse_tickets_from_url/",
  // Custom providers
  customProviders: baseUrl + "/admin/custom_providers/",
};

export const GOOGLE_MAPS_JS_API_KEY = "AIzaSyBHMCnE5l_yQ3hUNs5YCsxk-V8fxO2HFeA";
export const REQ_TIMEOUT = 30 * 1000; // 30 seconds
export const MIN_PWD_LENGTH = 4; // Minimum characters in a password

export const messages = {
  usernameRequired: "Username is required.",
  passwordRequired: "Password is required.",
  invalidPass:
    "Password must contain at least " + MIN_PWD_LENGTH + " characters.",
  invalidConfirmPass: "Please provide valid confirm password.",
  notMatchPass: "Password and confirm password should match.",
  requiredFieldsError: "Please fill all fields.",
  requestTimeout: "Timeout, server didn't respond within time.",
  serverError: "Server error",
  dataSaved: "Data successfully saved.",
  dataDeleted: "Data deleted successfully.",
  wrongImageSize: "Please refer the standard image size.",
  userStatusUpdate: "Status updated successfully.",
  ticketUpdate: "Ticket updated successfully.",
  cancelTicket: "Ticket cancelled successfully.",
  fakeTicketRequestApproved: "Request approved successfully.",
  fakeTicketRequestRejected: "Request rejected successfully.",
  loading: "Loading...",
  noUserFound: "No User Found",
  invalidDates: "From date should be less than To date.",
  ottPlayerRequired: "Please select an OTT player.",
  invalidUrl: "Invalid URL.",
  invalidDiscount: "Invalid discount.",
  bannerImageRequired: "Please select a banner image.",
  enterEmailPlaceholder: "Enter user's email id",
  addMoreUserPlaceholder: "+Add more users",
  enterContactNoPlaceholder: "Enter contact numbers",
  unauthorizedRequest: "Unauthorized request",
  uploadTicketImage: "Image uploaded successfully.",
  createNewTicket: "Ticket created successfully.",
  deleteTicket: "Ticket deleted successfully.",
  reportedSellerRejected: "Reported user rejected successfully.",
  reportedSellerApproved: "Reported user approved successfully.",
  flagTicketCountUpdated: "Flag ticket threshold count updated successfully.",
};

export const successNotificationOptions = {
  timeOut: 5000,
  showProgressBar: false,
  pauseOnHover: true,
  clickToClose: true,
  maxLength: 100,
  theClass: "notification-background",
};

export const errorNotificationOptions = {
  timeOut: 5000,
  showProgressBar: false,
  pauseOnHover: true,
  clickToClose: true,
  maxLength: 100,
  theClass: "notification-background",
};

export const notificationOptions = {
  position: ["bottom", "right"],
  timeOut: 5000,
  lastOnBottom: true,
  maxStack: 1,
};

export const imageSize = {
  1: { width: 90, height: 90 },
  2: { width: 192, height: 40 },
  3: { width: 263, height: 140 },
};

export const categories: Category[] = [
  { category_id: 1, name: "Concert" },
  // {category_id: 2, name: 'Sports'},
  { category_id: 3, name: "Theater" },
  { category_id: 9, name: "Cinema" },
  { category_id: 4, name: "Other" },
];

export const currencies: Currency[] = [
  { currency: "EUR", symbol: "€" },
  // { currency: 'BSD', symbol: '$' }
];

export const ticketStatus: any = {
  0: "",
  1: "Active",
  2: "Cancelled",
  3: "Expired",
  4: "Sold",
};

export const mapOptions: any = {
  latitude: 52.52000013647022,
  longitude: 13.40499971061945,
  initialZoom: 4,
  searchZoom: 16,
};

// United States
// latitude: 39.8282,
// longitude: -98.5795,

// Eurozone Nations
// latitude: 52.133487777532,
// longitude: 12.260741999999937,



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/app.constants.ts